// components/SecureComponent.jsx
import React from 'react';
import { useRBAC } from '../hooks/useRBAC';

/**
 * Wrapper component that conditionally renders children based on user's roles
 * @param {Object} props
 * @param {React.ReactNode} props.children - The components to render if user has permission
 * @param {Array<string>} props.requiredRoles - Roles required to render children
 * @param {React.ReactNode} props.fallback - Component to render if user lacks permission (optional)
 */
const SecureComponent = ({
                             children,
                             requiredRoles = ["LeadLens AI User"],
                             fallback = null
                         }) => {
    const { hasRole, isLoading } = useRBAC(requiredRoles);

    if (isLoading) {
        return null; // Or a loading spinner
    }

    if (!hasRole) {
        console.log("User does not have role " + JSON.stringify(requiredRoles));
        return fallback;
    }

    return <>{children}</>;
};

export default SecureComponent;
